<template>
    <v-container fluid pa-0>
        <v-layout row wrap v-if="$basket.getTotalDiscount()" class="font-weight-bold">
            <v-flex xs8>
                {{ 'discount' | translation }}
            </v-flex>
            <v-flex xs4 text-xs-right>
                - {{$basket.getTotalDiscount() | currency}}
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-end>
            <v-flex shrink>
                <p class="mb-0 headline font-weight-bold text-uppercase">{{ 'Total' | translation }}</p>
            </v-flex>

            <v-flex shrink>
                <span class="headline font-weight-bold">{{$basket.getBasketTotal() | currency}}</span>
                <p class="caption mb-0 font-weight-thin text-xs-right">{{ 'incl. VAT' | translation }}</p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'BasketTotals'
    };
</script>